import api from "../../api";

const state = {
	firstTime:	true,
	isLoggedIn:	false,
	name:		"",
	email:	"",
	org:		"",
	data:		{},
	clientId:	null,
	rights: {}
};

let tid = null;

const mutations = {
	set( state, data ) {
		if ( data.isLoggedIn ) {
			state.isLoggedIn = true;
			state.name		= data.name || "???";
			state.email		= data.email;
			state.org		= data.org || "";
			state.data		= data.data || {};
			state.clientId  = data.clientId || null;
			state.rights = data.rights || {};
		}
		else {
			state.isLoggedIn = false;
			state.name		= "";
			state.email		= "";
			state.org		= "";
			state.data		= {};
			state.clientId  = null;
			state.rights = {};
		}
	},
	
	setData( state, data ) {
		if ( state.isLoggedIn ) {
			state.data = data;
		}
	},

	setUserName( state, name ) {
		state.name = name;
	},
	
	setLoggedIn( state, isLoggedIn ) {
		state.isLoggedIn = isLoggedIn;
		if ( !isLoggedIn ) state.name = "";
	}
};

const actions = {
	async obtain( ctx ) {
		const data = await api.post.json( "/login", undefined, { notify: false } );

		if ( data && data.success === true) {
			ctx.commit(
				"set",
				{
					...data,
					isLoggedIn:	true
				}
			);
		}
	},
	async logout( ctx ) {
		await api.get.text( "/logout" );
		
		if ( ctx.state.isLoggedIn ) {
			ctx.commit(
				"set",
				{
					isLoggedIn:	false
				}
			);
		}
	},
	async setDataPart( ctx, data ) {
		if ( !data.name ) throw new Error( "mandatory field is empty" );
		if ( tid ) clearTimeout( tid );
		
		if ( JSON.stringify( data.data ) !== JSON.stringify( ctx.state.data[ data.name ] ) ) {
			ctx.commit(
				"setData",
				{
					...ctx.state.data,
					[ data.name ]: data.data
				}
			);
	
			tid = setTimeout(
				() => {
					tid = null;
					api.post.json(
						"/user",
						ctx.state.data
					);
				},
				1000
			);
		}
	}
};

const getters = {
	getDataPart: state => ( part => part ? state.data[ part ] : state.data ),
	getName: state => ( () => state.isLoggedIn ? state.name : "???" ),
	getEmail: state => ( () => state.isLoggedIn ? state.email : "" ),
	getClientId: state => ( () => state.isLoggedIn ? state.clientId : null ),
	getRights: state => ( () => state.isLoggedIn ? state.rights : {} )
};

export default {
	namespaced: true,
	strict:     true,
	state,
	mutations,
	actions,
	getters
};
